import renderShortcodes from "./shortcodes";
import { renderFields } from "./fields";

// Make it pretty
renderShortcodes()
renderFields()

